import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import { SvgIcon } from '../../../../../../../common/react/components/SvgIcon';
import { useWindowSize } from '../../../../../../../common/react/hooks/use-window-resize';

const SCROLL_DISTANCE_PX = 150;
const SCROLL_DEBOUNCE_MS = 100;

export const TableScrollButtons = ({ scrollWrapperRef, scrollPosition }) => {
    const [canScroll, setCanScroll] = useState({ left: false, right: true });

    const windowSize = useWindowSize();

    // @ts-ignore
    const recalculateCanScrollValues = _.debounce(() => {
        if (!scrollWrapperRef.current) {
            return;
        }

        const { scrollWidth, clientWidth } = scrollWrapperRef.current;

        setCanScroll({
            left: scrollPosition !== 0,
            right: scrollPosition !== scrollWidth - clientWidth
        });
    }, SCROLL_DEBOUNCE_MS);

    useEffect(() => {
        recalculateCanScrollValues();
    }, [scrollPosition, windowSize]);

    return (
        <div className="stats-table-scroll-buttons">
            <button
                disabled={!canScroll.left}
                className="stats-table-scroll-button stats-table-scroll-button--left"
                onClick={() =>
                    scroll(scrollWrapperRef.current, -SCROLL_DISTANCE_PX)
                }
            >
                <SvgIcon
                    icon="chevron-v2-left"
                    className="stats-table-scroll-button__icon"
                />
            </button>
            <button
                disabled={!canScroll.right}
                className="stats-table-scroll-button stats-table-scroll-button--right"
                onClick={() =>
                    scroll(scrollWrapperRef.current, SCROLL_DISTANCE_PX)
                }
            >
                <SvgIcon
                    icon="chevron-v2-right"
                    className="stats-table-scroll-button__icon"
                />
            </button>
        </div>
    );
};

const scroll = (elem, left) => {
    elem.scrollBy({ left, behavior: 'smooth' });
};

TableScrollButtons.propTypes = {
    scrollWrapperRef: PropTypes.object.isRequired,
    scrollPosition: PropTypes.number.isRequired
};
